import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const SidebarTeaser = ({
  image,
  title,
  subtitle,
  slug,
}) => {
  const imageSrc = getImage(image)

  return (
    <div className="sidebar-teaser position-relative">
      <div className="row">
        <div className="col-3">
          <GatsbyImage
            image={imageSrc}
            alt={title}
          />
        </div>
        <div className="col-9">
          <div className="h4">
            {title}
          </div>
          <small className="text-muted">
            {subtitle}
          </small>
        </div>
      </div>

      <Link
        className="position-absolute top-0 left-0 w-100 h-100 d-block opacity-0"
        to={slug}
      >
        {title}
      </Link>
    </div>
  )
}

SidebarTeaser.defaultProps = {
  subtitle: null,
}

SidebarTeaser.propTypes = {
  image: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  slug: PropTypes.string.isRequired,
}

export default SidebarTeaser
